// This file is generated by pnpm icons:generate. Do not edit.

import {createSVG} from '../TEMPLATE'

export const Eyedropper = createSVG({
  elements: [
    {
      fill: 'currentColor',
      stroke: 'none',
      type: 'path',
      d: 'M21 6.31a3.36 3.36 0 0 0-1.056-2.406c-1.312-1.245-3.442-1.198-4.745.106l-1.811 1.82a2.25 2.25 0 0 0-3.107.072l-.844.844a1.5 1.5 0 0 0 0 2.123l.187.193-4.78 4.781a3.73 3.73 0 0 0-.988 3.563l-.75 1.725a1.28 1.28 0 0 0 .269 1.427 1.49 1.49 0 0 0 1.66.314l1.643-.717a3.74 3.74 0 0 0 3.474-1.008l4.781-4.78.194.192a1.5 1.5 0 0 0 2.12 0l.844-.843a2.25 2.25 0 0 0 .07-3.111l1.85-1.863A3.35 3.35 0 0 0 21 6.31ZM9.094 18.093a2.25 2.25 0 0 1-2.25.562.75.75 0 0 0-.52.03l-1.697.74.717-1.669a.75.75 0 0 0 .023-.539 2.24 2.24 0 0 1 .54-2.312l4.78-4.781 3.182 3.188ZM18.95 7.687l-2.38 2.393a.75.75 0 0 0 0 1.06l.459.458a.75.75 0 0 1 0 1.061l-.844.844L10.5 7.806l.844-.844a.75.75 0 0 1 1.06 0l.459.458a.75.75 0 0 0 1.062 0l2.338-2.352c.732-.733 1.922-.767 2.652-.076a1.875 1.875 0 0 1 .037 2.69Z',
      fillRule: 'evenodd',
    },
  ],
  viewBox: '0 0 24 24',
  glyph: 'Eyedropper',
})
